import { useState } from 'react'
import { useAsyncEffect } from 'utils'
import { MediaSprite } from '../types'
import { mediaSpriteFromSource } from '../utils/media/sprite'

const useMediaSprite = (
    source: File | string,
    maxFrameWidth?: number,
    fps?: number,
    cacheResults?: boolean
): MediaSprite | undefined => {
    const [sprite, setSprite] = useState<MediaSprite | undefined>()

    useAsyncEffect(async () => {
        try {
            const mediaSprite = await mediaSpriteFromSource(source, maxFrameWidth, fps, cacheResults)
            setSprite(mediaSprite)
        } catch (err) {
            setSprite(undefined)
        }
    }, [cacheResults, fps, maxFrameWidth, source])

    return sprite
}

export default useMediaSprite
